import { createTheme } from "@material-ui/core";

export const defaultTheme = createTheme({
    palette: {
      primary: {
        main: '#0e328c',
      },
      secondary: {
        main: '#c21e38',
      },
    },
});

export const pinkTheme = createTheme({
    palette: {
      primary: {
        main: '#B23FB5',
      },
      secondary: {
        main: '#c21e38',
      },
    },
});

export const purpleTheme = createTheme({
    palette: {
      primary: {
        main: '#5F3FB5',
      },
      secondary: {
        main: '#c21e38',
      },
    },
});